import { isEmpty } from "lodash-es";

export const getCompleteSlug = (slug: string[] | string, basePath: string = ""): string => {
    const parsedSlug = Array.isArray(slug) ? slug : !isEmpty(slug) ? [slug] : [];

    return [basePath, ...parsedSlug].join("/");
};
